export default __webpack_public_path__ + "static/media/Bullet 04.f1a65e9e.webp";